module.exports = __webpack_public_path__ + "static/media/rose.c5db23e0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/rose.mp4
// module id = 34
// module chunks = 0